module.exports = __webpack_public_path__ + "img/faq5.2993271e.png";